<template>
  <b-modal
    id="limitedPremiumModal"
    centered
    hide-footer
    hide-header
    hide-actions
    no-close-on-backdrop
  >
    <section class="c-modal c-modal--dark-blur c-modal--trial-premium">
      <div
        class="c-modal__dialog"
      >
        <section
          class="p-4">
          <div class="d-flex flex-column align-items-center text-center">
            <h3 class="w-bold fs-25 white">¡Limite de 20 lecciones/día excedido!</h3>
            <p class="mb-5">Podrás volver a disfrutar de <span class="w-bold">Arcux</span> en:</p>

            <Timer v-if="dateEnd" :end="dateEnd" class="mb-5" />

            <button
              @click="close()"
              class="c-button c-button--primary-ghost medium"
            >
              Cerrar mensaje
            </button>
          </div>
        </section>
      </div>
    </section>
  </b-modal>
</template>

<script>
export default {
  props: {
    course: Object,
  },
  components: {
    Timer: () => import(/* webpackChunkName: "timer" */'@/components/Timer.vue'),
  },
  computed: {
    dateEnd() {
      return this.course.enroll.data.trial.limit_day_expiration_date;
    },
  },
  methods: {
    close() {
      this.$bvModal.hide('limitedPremiumModal');
    },
  },
};
</script>
